import Swiper, {Navigation, Autoplay} from 'swiper';

Swiper.use([Navigation, Autoplay]);

const runCond = document.querySelector('#single-influenceur');

const influenceur = {
	init: function () {
		// swiper
		new Swiper('.swiperSingleInfluenceur', {
			slidesPerView: 'auto',
			spaceBetween: 30,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			on: {
				init: function () {
					console.log('swiper initialized');
				},
			},
		});

		new Swiper('.swiperCollabs', {
			slidesPerView: 1,
			spaceBetween: 24,
			autoplay: {
				delay: 3000,
			}
		})

		this.attachEvents();
	},

	attachEvents: function () {
	},
};

if (runCond) {
	influenceur.init();
}



// WEBPACK FOOTER //
// ./scripts/single-influenceur.js